import { InputModel } from 'Components/Forms/RenderFormField';

interface InputFieldProps {
    field: InputModel;
}

const HiddenField = ({ field }: InputFieldProps) => {
    const { type, value, name } = field;
    return (
        <input
            className="hidden"
            type={type}
            defaultValue={value}
            name={name}
            id={name}
        />
    );
};
export default HiddenField;
